
export default {
  items: [
    {
      moduleCode: 'BCM',
      screenCode: '',
      name: 'Organisation Structure Setup',
      url: '/organisation_structure_setup',
      icon: 'icon-bcmAdmin_1',
      class: 'parent-nav',

      children: [
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM126', //BCMFRM126
          name: 'Admin Level',
          url: '/bcmadmin/organisation_structure_setup/admin_level',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ]
    },
    {
      moduleCode: 'BCM',
      screenCode: '',
      name: 'Setup Department/Station Administration',
      url: '/setup_scorecard_administration',
      icon: 'icon-bcmAdmin_2',
      class: 'parent-nav',
      children: [
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM127', //ADMFRM101
          name: 'Department/Station Setup',
          url: '/bcmadmin/scorecard-level-list',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ],
    },
    {
      moduleCode: 'BCM',
      screenCode: '',
      name: 'BCM Setup',
      url: '/bcmsetup',
      icon: 'icon-bcmAdmin_3',
      class: 'parent-nav',
      children: [
        {
          moduleCode: 'BCM',
          screenCode: '',
          name: 'Department Info',
          url: '/department_info',
          icon: 'icon hidden',
          class: 'child-nav child-2',
          children: [
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM128', //ADMFRM101
              name: 'Department Setup',
              url: '/bcmadmin/bcmsetup/altsitesetup/division',
              icon: 'icon hidden',
              class: 'child-nav level2',
            },
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM129', //ADMFRM101
              name: 'Sub Department/Main Site Setup',
              url: '/bcmadmin/bcmsetup/altsitesetup/production',
              icon: 'icon hidden',
              class: 'child-nav level2',
            },
          ],
        },
        {
          moduleCode: 'BCM',
          screenCode: '',
          name: 'MBCO',
          url: '/mbco',
          icon: 'icon hidden',
          class: 'child-nav child-2',
          children: [
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM130',
              name: 'Setup MBCO',
              url: '/bcmadmin/setupmbco/setupmbcolist',
              icon: 'icon hidden',
              class: 'child-nav',
            },
          ],
        },
        {
          moduleCode: 'BCM',
          screenCode: '',
          name: 'BIA',
          url: '/bia',
          icon: 'icon hidden',
          class: 'child-nav child-2',
          children: [
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM131',
              name: 'Criticality Setup',
              url: '/bcmadmin/criticalitysetup/criticalitysetuplist',
              icon: 'icon hidden',
              class: 'child-nav',
            },
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM132',
              name: 'Frequency',
              url: '/bcmadmin/bcmsetup/business-function-frequency',
              icon: 'icon hidden',
              class: 'child-nav',
            },
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM133',
              name: 'Impact Rating Setup',
              url: '/bcmadmin/bcmsetup/impact-rating-setup-list',
              icon: 'icon hidden',
              class: 'child-nav',
            },
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM134',
              name: 'Impact Type',
              url: '/bcmadmin/bcmsetup/business-function-impacttype',
              icon: 'icon hidden',
              class: 'child-nav',
            },
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM135',
              name: 'BIA Name',
              url: '/bcmadmin/bcmsetup/businessfunctionstationsetup/station-setup',
              icon: 'icon hidden',
              class: 'child-nav',
            },
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM152',
              name: 'Business Function Who In-Charge',
              url: '/bcmadmin/bcmsetup/businessfunctioncbfInChargeSetup/cbfInCharge',
              icon: 'icon hidden',
              class: 'child-nav',
            },
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM136',
              name: 'Resource Type and Time Horizon',
              url: '/bcmadmin/bcmsetup/resourceTime',
              icon: 'icon hidden',
              class: 'child-nav',
            },
          ],
        },
        {
          moduleCode: 'BCM',
          screenCode: '',
          name: 'IT Applications',
          url: '/it_applications',
          icon: 'icon hidden',
          class: 'child-nav child-2',
          children: [
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM137',
              name: 'System',
              url: '/bcmadmin/bcmsetup/it-system-listing',
              icon: 'icon hidden',
              class: 'child-nav',
            },
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM138',
              name: 'Sub-System',
              url: '/bcmadmin/bcmsetup/it-sub-system-listing',
              icon: 'icon hidden',
              class: 'child-nav',
            },
          ],
        },
        {
          moduleCode: 'BCM',
          screenCode: '',
          name: 'Internal And External Dependencies',
          url: '/internal_and_external_depndencies',
          icon: 'icon hidden',
          class: 'child-nav child-2',
          children: [
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM139',
              name: 'Impact of non-availability',
              url: '/bcmadmin/bcmsetup/admin-non-availability-impact',
              icon: 'icon hidden',
              class: 'child-nav',
            },
          ],
        },
        {
          moduleCode: 'BCM',
          screenCode: '',
          name: 'Vital Record',
          url: '/vital_record',
          icon: 'icon hidden',
          class: 'child-nav child-2',
          children: [
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM140',
              name: 'Media Type',
              url: '/bcmadmin/bcmsetup/vital-record',
              icon: 'icon hidden',
              class: 'child-nav',
            },
          ],
        },
        {
          moduleCode: 'BCM',
          screenCode: '',
          name: 'Recovery Plan',
          url: '/recovery_plan',
          icon: 'icon hidden',
          class: 'child-nav child-2',
          children: [
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM141',
              name: 'Risk Category Setup',
              url: '/bcmadmin/bcmsetup/risk-category-setup',
              icon: 'icon hidden',
              class: 'child-nav',
            },
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM142',
              name: 'Sub-Risk Category Setup',
              url: '/bcmadmin/bcmsetup/risk-sub-category-setup',
              icon: 'icon hidden',
              class: 'child-nav',
            },
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM155',
              name: 'Responsibility',
              url: '/bcmadmin/bcmsetup/recoveryactiontype',
              icon: 'icon hidden',
              class: 'child-nav',
            },
          ],
        },
        {
          moduleCode: 'BCM',
          screenCode: '',
          name: 'Emergency Response',
          url: '/emergency_response',
          icon: 'icon hidden',
          class: 'child-nav child-2',
          children: [
            {
              moduleCode: 'BCM',
              screenCode: 'BCMFRM143',
              name: 'Agencies',
              url: '/bcmadmin/emergencyresponse',
              icon: 'icon hidden',
            },
          ],
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM144',
          name: 'Emergency Operation Center',
          url: '/bcmadmin/emergencycommandcenter',
          icon: 'icon hidden',
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM124',
          name: 'Crisis Management Team',
          url: '/bcmadmin/crisis-management-team',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM125',
          name: 'Roles & Responsibilities',
          url: '/bcmadmin/roles-and-responsibilities',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM145',
          name: 'Return To Normal Operation',
          url: '/bcmadmin/return-to-normal-operation',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ],
    },
    {
      moduleCode: 'BCM',
      screenCode: '',
      name: 'Department and Access Setup',
      url: '/department_and_access_setup',
      icon: 'icon-bcmAdmin_4',
      class: 'parent-nav',
      children: [
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM146',
          name: 'Setup User Access Rights',
          url: '/bcmadmin/setupUseraccessright/setupuseraccessrightlist',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM184',
          name: 'Setup User Workflow Right',
          url: '/bcmadmin/setup-user-workflow-right',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ],
    },
    {
      moduleCode: 'BCM',
      screenCode: '',
      name: 'Communication',
      url: '/communication',
      icon: 'icon-bcmAdmin_5',
      class: 'parent-nav',
      children: [
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM147',
          name: 'Broadcast Email',
          url: '/bcmadmin/broadcastemail',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM148',
          name: 'Maintain Annoucement Board',
          url: '/bcmadmin/annoucementsetup',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ],
    },
    {
      moduleCode: 'BCM',
      screenCode: '',
      name: 'Reporting Frequency Setup',
      url: '/reporting_frequency_setup',
      icon: 'icon-bcmAdmin_6',
      class: 'parent-nav',
      children: [
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM149',
          name: 'Profile Maintenance',
          url: '/bcmadmin/profile-maintenance',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM150',
          name: 'Frequency Setup',
          url: '/bcmadmin/frequency-setup',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        //{
        //  moduleCode: 'BCM',
        //  screenCode: 'BCMFRM151',
        //  name: 'Profile Sub Admin',
        //  url: '/bcmadmin/reporting-frequency-setup/profile-access-setup-for-subadmin',
        //  icon: 'icon hidden',
        //  class: 'child-nav',
        //},
      ],
    },
    {
      moduleCode: 'BCM',
      screenCode: '',
      name: 'Fiscal Year Setup',
      url: '/fiscal_year_setup',
      icon: 'icon-bcmAdmin_7',
      class: 'parent-nav',
      children: [
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM154',
          name: 'Fiscal Year Maintenance',
          url: '/bcmadmin/fiscalyearmaintenance',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ],
    },
    {
      moduleCode: 'BCM',
      screenCode: '',
      name: 'Reporting Setup',
      url: '/reporting_setup',
      icon: 'icon-notebook',
      class: 'parent-nav',
      children: [
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM178',
          name: 'Abbreviation Setup',
          url: '/bcmadmin/abbreviationsetup',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ],
    },
    {
      moduleCode: 'BCM',
      screenCode: '',
      name: 'Report Query',
      url: '/report_query',
      icon: 'icon-notebook',
      class: 'parent-nav',
      children: [
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM156',
          name: 'Setup Report Type',
          url: '/bcmadmin/setupreportquerytype',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM157',
          name: 'Setup Report Query Column',
          url: '/bcmadmin/setupreportquerycolumn',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ],
    },
  ],
};

